/* eslint-disable */
import type { ThreeDomainSecureRedirectUrl } from "../sca/three_domain_secure.pb";

/** Valid values for transaction_type in ThreeDomainSecureV2Blocker. */
export enum ThreeDomainSecureV2BlockerTransactionType {
  PAYMENT = "PAYMENT",
  CARD_LINK = "CARD_LINK",
}

/** Environments to run Adyen 3DS2 Actions in. */
export enum ThreeDomainSecureV2AdyenEnvironment {
  TEST = "TEST",
  EUROPE = "EUROPE",
  UNITED_STATES = "UNITED_STATES",
  AUSTRALIA = "AUSTRALIA",
  /**
   * LIVE - Deprecated in favour of specfic country envs. Adyen android SDK has the comment:
   * "Use the same live environment as your back end instead. You can find that value in your Customer Area."
   * https://github.com/Adyen/adyen-android/blob/v4/checkout-core/src/main/java/com/adyen/checkout/core/api/Environment.java#L35-L39
   *
   * @deprecated
   */
  LIVE = "LIVE",
}

/** 3-D Secure blocker that shows a web page challenge. */
export interface ThreeDomainSecureRedirectBlocker {
  challenge_url?: string;
  header_title?: string;
  header_subtitle?: string;
  redirect_url?: ThreeDomainSecureRedirectUrl;
  /** A contextual text to show when the customer is loading the 3DS challenge. */
  spinner_message?: string;
  /** The spinner message will be shown after a number of seconds have passed. */
  spinner_message_delay_s?: number;
  /**
   * Indicates the transaction type this blocker is a part of. Defined as a string and not enum in order to support
   * old clients. See ThreeDomainSecureV2BlockerTransactionType for valid values.
   */
  transaction_type?: string;
  /** e.g. payment_token, instrument_token, etc. */
  transaction_id?: string;
}

export interface ThreeDomainSecureV2Blocker {
  header_title?: string;
  /** Contains base64-encoded action object provided by Adyen */
  action_data?: string;
  /**
   * Indicates the transaction type this blocker is a part of. Defined as a string and not enum in order to support
   * old clients. See ThreeDomainSecureV2BlockerTransactionType for valid values.
   */
  transaction_type?: string;
  /** e.g. payment_token, instrument_token, etc. */
  transaction_id?: string;
  /** Adyen environment. */
  environment?: ThreeDomainSecureV2AdyenEnvironment;
}
